// Plugins
import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

let mm = gsap.matchMedia();

document.addEventListener("DOMContentLoaded", (e) => {
	mm.add("(min-width: 800px)", () => {
		let member_ctn = document.getElementById("member");
		let member_image_ctn = document.getElementById("member-image-wrapper");
		let member_plx_image = document.querySelector(".plx-image");
		let member_content = document.querySelector(".member__ctn .container");
		let member_title_ctn = document.querySelector(".member__title");
		let member_infos_ctn = document.querySelector(".member__infos");

		gsap.from(member_title_ctn, { y: 100, opacity: 0, duration: 1 });
		gsap.from(member_plx_image, { y: -100, duration: 2 }, "<");

		const PinnedHero = ScrollTrigger.create({
			trigger: member_ctn,
			start: "top top-=0px",
			end: (st) => "+=" + (st.vars.trigger.getBoundingClientRect().height - window.innerHeight),
			pin: member_image_ctn,
		});

		gsap.to(member_plx_image, {
			yPercent: -15,
			duration: member_ctn.getBoundingClientRect().height,
			scrollTrigger: {
				trigger: member_ctn,
				start: "top top",
				end: "bottom 50%",
				scrub: true,
			},
		});

		gsap.to(member_content, {
			yPercent: -10,
			ease: "power1.out",
			duration: 2.5,
			scrollTrigger: {
				trigger: member_ctn,
				start: "top top-=0px",
				end: "bottom 50%",
				scrub: 1.5,
			},
		});
	});
});
